"use client";

import { useMutation } from "@tanstack/react-query";
import type { UpdatePersonalDataRequest } from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { updatePersonalData } from "../api/updatePersonalData";

export default function useUpdatePersonalDataMutation() {
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: UpdatePersonalDataRequest) =>
      updatePersonalData(accessToken, request),
  });
}
